import React, { useState, useEffect, useRef } from "react";
import { Col } from "@themesberg/react-bootstrap";
import StaffTable from "./components/StaffTable";
import StaffFilter from "./components/StaffFilter";
import PaginationComponent from "../../../components/Pagination";
import useTableCustom from "../../../components/CusotmFilter"

import Preloader from "../../../components/Preloader";
import { AdminsRoutes } from "../../../routes";
import useCheckPermission from "../../../utils/checkPermission";
import { searchRegEx } from "../../../utils/helpers";
import useStaffListing from "./hooks/useStaffListing";
import {
  SectionHeaderWrap,
  TableBg,
  HeaderRow
} from "../../../components/StyledComponents";
import { AddButtonStyled, ButtonContainer, ResponsiveTitle } from "../TransactionsBanking/style";
import NotificationIconContainer from "../../../components/NotificationIcon/NotificationIconContainer";
import { motion } from 'framer-motion/dist/framer-motion';
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import { DeleteModal, StatusChangeModal } from "./components/modals";
import { staffTableHeaders as tableHeaders } from "./constants";
import TableErrorMessage from "../../../components/TableErrorMessage";


const Staff = () => {
  const {
    navigate,
    loading,
    limit,
    setLimit,
    page,
    setPage,
    setOrderBy,
    sort,
    setSort,
    setSearch,
    search,
    show,
    setShow,
    data,
    totalPages,
    getRole,
    handleShow,
    handleYes,
    selected,
    selectedStaff,
    active,
    handleDeleteModal,
    handleDeleteYes,
    deleteModalShow,
    setDeleteModalShow,
    isValidOrderBy,
    staffStatus, setStaffStatus,
    staffRole, setStaffRole,
    adminRoles,
    onHandleResetFilter,
    totalCount
  } = useStaffListing();

  const { isHidden } = useCheckPermission();

  const {
    visibleColumns,
    pageData,
    customColSetting,
    noDataFound,

  } = useTableCustom(data,
    tableHeaders,
    false,
    () => { },
    null,
    null,
    false,
    "",
    true,
    "staff_managment_table");


  const headerRef = useRef(null);
  const filterRef = useRef(null);
  const paginationRef = useRef(null);
  const [tableMaxHeight, setTableMaxHeight] = useState();

  useEffect(() => {
    const updateMaxHeight = () => {
      const headerHeight = headerRef.current?.offsetHeight || 0;
      const filterHeight = filterRef.current?.offsetHeight || 0;
      const paginationHeight = paginationRef?.current?.offsetHeight || 0;

      const responsiveTable = document.querySelector('.table-responsive');
      const totalHeight = headerHeight + filterHeight + paginationHeight;
      const availableHeight = window.innerHeight - totalHeight - 130;

      if (window.innerWidth < 1000) {
        // For smaller screens: reset to full height
        if (responsiveTable) {
          responsiveTable.style.maxHeight = '100%';
          responsiveTable.style.overflowY = 'unset';
        }
        setTableMaxHeight('100%');
        return;
      }
      else if (responsiveTable) {
        responsiveTable.style.maxHeight = `${availableHeight}px`;
        responsiveTable.style.overflowY = 'auto'; // ensure scrolling
      }

      setTableMaxHeight(`${availableHeight}px`);
    };

    updateMaxHeight();
  }, []);
  return (
    <>
      {/* Header Section */}
      <SectionHeaderWrap ref={headerRef} className="pt-4">
        <HeaderRow>
          <Col xs={12} md={6}>
            <ResponsiveTitle className="title-text">
              Staff Management
            </ResponsiveTitle>
          </Col>

          <Col xs={12} md={6}>
            <ButtonContainer className="d-flex justify-content-md-end">
              <motion.div
                initial={{ opacity: 0, scale: 0.5 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}
                className="flex-grow-1 flex-md-grow-0"
              >
                <AddButtonStyled
                  variant="primary"
                  onClick={() => navigate(AdminsRoutes.CreateStaff)}
                  hidden={isHidden({ module: { key: "Admins", value: "C" } })}
                >
                  <AddCircleOutlineRoundedIcon />
                  <span>Create Staff</span>
                </AddButtonStyled>
              </motion.div>
              <div className="ms-auto ms-md-2">

                <NotificationIconContainer />
              </div>
            </ButtonContainer>
          </Col>
        </HeaderRow>
      </SectionHeaderWrap>

      {/* Filter Section */}
      <div ref={filterRef}>
        <StaffFilter
          search={search}
          setSearch={setSearch}
          searchRegEx={searchRegEx}
          setPage={setPage}
          customColSetting={customColSetting}

          staffStatus={staffStatus} setStaffStatus={setStaffStatus}
          staffRole={staffRole} setStaffRole={setStaffRole}
          adminRoles={adminRoles}
          onHandleResetFilter={onHandleResetFilter}


        />
      </div>


      {/* Table Section */}
      {visibleColumns?.length > 0 ? <TableBg className="px-0">
        <StaffTable
          loading={loading}
          data={{ rows: data }}
          navigate={navigate}
          selected={selected}
          sort={sort}
          setSort={setSort}
          setOrderBy={setOrderBy}
          getRole={getRole}
          handleShow={handleShow}
          handleDeleteModal={handleDeleteModal}
          isHidden={isHidden}
          isValidOrderBy={isValidOrderBy}
          visibleColumns={visibleColumns}
          pageData={data}
          tableMaxHeight={tableMaxHeight}
          paginationRef={paginationRef}
        />

        {/* Pagination */}
        {data && data.length > 0 && (
          <PaginationComponent
            page={page}
            totalPages={totalPages}
            setPage={setPage}
            limit={limit}
            setLimit={setLimit}
            showTotalCount={true}
            totalCount={totalCount}
            countText={"Total Staff: "}
          />
        )}
      </TableBg> : <TableErrorMessage />}

      {loading && <Preloader />}

      <StatusChangeModal
        show={show}
        setShow={setShow}
        handleYes={handleYes}
        active={active}
        selectedStaff={selectedStaff}
        loading={loading}
      />

      <DeleteModal
        show={deleteModalShow}
        setShow={setDeleteModalShow}
        handleDeleteYes={handleDeleteYes}
        selectedStaff={selectedStaff}
        loading={loading}
      />
      <StatusChangeModal
        show={show}
        setShow={setShow}
        handleYes={handleYes}
        active={active}
        selectedStaff={selectedStaff}
        loading={loading}
      />

      <DeleteModal
        show={deleteModalShow}
        setShow={setDeleteModalShow}
        handleDeleteYes={handleDeleteYes}
        selectedStaff={selectedStaff}
        loading={loading}
      />
    </>
  );
};

export default Staff;
